export default __webpack_public_path__ + "static/media/coin-horizontal.07b1c2e5.png";